export enum LifeEndpoints {
    GetInfo = "insureds/:userIdentity/insurances/life/policies/:policyId/info",
}
